var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 803,
    height: 402,
    viewBox: "0 0 803 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.714 0C69.2464 0 0 101.361 0 200.714C0 300.068 69.2464 401.429 200.714 401.429C279.996 401.429 343.221 345.229 401.429 278.993C459.636 345.229 520.854 401.429 602.143 401.429C733.611 401.429 802.857 300.068 802.857 200.714C802.857 101.361 733.611 0 602.143 0C520.854 0 459.636 56.2 401.429 122.436C343.221 56.2 279.996 0 200.714 0ZM200.714 100.357C242.864 100.357 289.029 147.525 335.193 200.714C289.029 253.904 242.864 301.071 200.714 301.071C126.45 301.071 100.357 246.879 100.357 200.714C100.357 154.55 126.45 100.357 200.714 100.357ZM602.143 100.357C676.407 100.357 702.5 154.55 702.5 200.714C702.5 246.879 676.407 301.071 602.143 301.071C558.989 301.071 512.825 253.904 467.664 200.714C513.829 147.525 558.989 100.357 602.143 100.357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.cc793d3b884745e89d39b17760e41d4a.svg";
export { ForwardRef as ReactComponent };